// extracted by mini-css-extract-plugin
export default {"cont":"SpecOffer_cont__CGlyP","loader":"SpecOffer_loader__+4BUP"};